import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
function AuditLog() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState({
        module: "",
        action: "",
    });
    useEffect(() => {
        getAuditLogs();
    }, []);
    const getAuditLogs = () => {
        setLoading(true);
        axios
            .get(baseUrl + "audit-log/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire("Error",
                    "Unable to load audit logs",
                    "error");
            });
    };
    const handleFilter = (e) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };
    const filteredRows = rows.filter((item) => {
        return (
            (filter.module === "" || item.module
                ?.toLowerCase()
                .includes(filter.module.toLowerCase()))
            &&
            (filter.action === "" || item.action
                ?.toLowerCase()
                .includes(filter.action.toLowerCase()))
        );
    });
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 80
        },
        {
            field: "module",
            headerName: "Module",
            flex: 1
        },
        {
            field: "document_type",
            headerName: "Document",
            flex: 1
        },
        {
            field: "document_id",
            headerName: "Document ID",
            width: 120
        },
        {
            field: "action",
            headerName: "Action",
            width: 130,
            renderCell: (params) => (
                <span

                    className={
                        params.value === "DELETE"
                            ?
                            "badge bg-danger"
                            :
                            params.value === "CREATE"
                                ?
                                "badge bg-success"
                                :
                                "badge bg-primary"
                    }

                >

                    {params.value}

                </span>
            )
        }, {
            field: "user_name",
            headerName: "User",
            flex: 1
        },
        {
            field: "ip_address",
            headerName: "IP Address",
            width: 150
        },
        {
            field: "created_at",
            headerName: "Date",
            width: 180
        },
        {
            field: "action_view",
            headerName: "View",
            width: 120,
            renderCell: (params) => (
                <button

                    className="btn btn-sm btn-info"

                    onClick={() => {
                        Swal.fire({
                            title: "Audit Details",
                            html:
                                `

                            <b>Old Value</b>

                            <pre>

                            ${JSON.stringify(params.row.old_value, null, 2)}

                            </pre>


                            <b>New Value</b>

                            <pre>

                            ${JSON.stringify(params.row.new_value, null, 2)}

                            </pre>

                            `,
                            width: 700
                        })
                    }}

                >

                    View

                </button>
            )
        }
    ];
    const createCount = rows.filter(x => x.action === "CREATE").length;
    const updateCount = rows.filter(x => x.action === "UPDATE").length;
    const deleteCount = rows.filter(x => x.action === "DELETE").length;
    return (
        <div className="container-fluid mt-3">


            <div className="row mb-3">


                <div className="col-md-4">


                    <div className="card shadow">


                        <div className="card-body text-center">


                            <h6>
                                Created
                            </h6>


                            <h3 className="text-success">

                                {createCount}

                            </h3>


                        </div>


                    </div>


                </div>


                <div className="col-md-4">


                    <div className="card shadow">


                        <div className="card-body text-center">


                            <h6>
                                Updated
                            </h6>


                            <h3 className="text-primary">

                                {updateCount}

                            </h3>


                        </div>


                    </div>


                </div>


                <div className="col-md-4">


                    <div className="card shadow">


                        <div className="card-body text-center">


                            <h6>
                                Deleted
                            </h6>


                            <h3 className="text-danger">

                                {deleteCount}

                            </h3>


                        </div>


                    </div>


                </div>


            </div>


            <div className="card shadow">


                <div className="card-header bg-dark text-white">


                    <h5 className="mb-0">

                        Audit Log

                    </h5>


                </div>


                <div className="card-body">


                    <div className="row mb-3">


                        <div className="col-md-4">


                            <input

                                className="form-control"

                                placeholder="Filter Module"

                                name="module"

                                value={filter.module}

                                onChange={handleFilter}

                            />


                        </div>


                        <div className="col-md-4">


                            <input

                                className="form-control"

                                placeholder="Filter Action"

                                name="action"

                                value={filter.action}

                                onChange={handleFilter}

                            />


                        </div>


                    </div>


                    <div

                        style={{
                            height: 600,
                            width: "100%"
                        }}

                    >


                        <ERPDataGrid


                            rows={filteredRows}


                            columns={columns}


                            loading={loading}


                            getRowId={(row) => row.id}


                            pageSizeOptions={[
                                10,
                                25,
                                50,
                                100
                            ]}


                            disableRowSelectionOnClick


                        />


                    </div>


                </div>


            </div>


        </div>
    );
}
export default AuditLog;